// extracted by mini-css-extract-plugin
export default {"DrawerHeader":"index_DrawerHeader__F1taF","mainDrawer":"index_mainDrawer__VFjsT","scrollbarWrapper":"index_scrollbarWrapper__s7Jgd","formBody":"index_formBody__niita"};